import { render } from "./amount.vue?vue&type=template&id=21e8b0b5&scoped=true"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"

import "./amount.vue?vue&type=style&index=0&id=21e8b0b5&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e8b0b5"]])

export default __exports__